import { render, staticRenderFns } from "./UiDrawer.vue?vue&type=template&id=0c21ba63"
import script from "./UiDrawer.vue?vue&type=script&lang=js"
export * from "./UiDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports